import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// QUINLAN
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import UserModule from "@/store/modules/user.module";
import Loader from "../../../components/widgets/loader.vue";
import SectionLoader from "../../../components/widgets/SectionLoader.vue";
/**
 * View User Component
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let ViewUser = /** @class */ (() => {
    let ViewUser = class ViewUser extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.pageIsLoading = true;
            this.isPageLoading = false;
            this.title = "View User";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Users",
                    to: "/users",
                },
                {
                    text: "View User",
                    active: true,
                },
            ];
            this.ctaButtons = [
                {
                    routeName: "Users",
                },
            ];
        }
        //Methods
        //Computed
        get users() {
            return UserModule.user;
        }
        //Lifecycle
        created() {
            var userId = this.$route.params.userId;
            UserModule.ViewUser(userId).then((response) => {
                this.pageIsLoading = false;
            });
        }
    };
    ViewUser = __decorate([
        Component({
            name: "ViewUser",
            components: {
                Layout,
                PageHeader,
                SectionLoader,
                Loader,
            },
        })
    ], ViewUser);
    return ViewUser;
})();
export default ViewUser;
